/* eslint-disable prettier/prettier */
export type DisplaySentiment = 'Positive' | 'Negative' | 'Neutral';

export const toDisplaySentiment = (value?: string): DisplaySentiment | null => {
  const map = {
    positive: 'Positive',
    negative: 'Negative',
    neutral: 'Neutral',
  } as const;

  const normalized = (value ?? '').trim().toLowerCase();

  return map[normalized as keyof typeof map] ?? null;
};
